import { jsx } from "panel";
import { selx } from "clsx";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import styles from "./index.module.styl";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: selx(styles.mpQuerySamplingCta)
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-sampling-cta-title"
  }, "Use query sampling to get results faster"), /* @__PURE__ */ jsx(ButtonEl, {
    on: { click: this.handleEnableQuerySampling },
    attrs: { theme: ButtonTheme.Secondary, icon: `sampling` }
  }, "Re-run with query time sampling"));
}
